import { ReactComponent as SecurityShieldIcon } from "assets/images/icons/icon-shield-security.svg"
import { ReactComponent as TraceliumLogo } from "assets/images/logo-tracelium-terms-policy.svg"

const LoadingCheckWorkspace = () => {
  const label = "Verifying workspace access..."

  const renderLoadingContent = () => (
    <div className="flex flex-col items-center justify-center gap-6">
      <div className="relative" style={{ width: 120, height: 120 }}>
        <div
          className="absolute rounded-full"
          style={{
            width: 120,
            height: 120,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background:
              "linear-gradient(135deg, rgba(26, 71, 240, 0.1) 0%, rgba(253, 190, 68, 0.1) 100%)",
            animation: "pulse 2s ease-in-out infinite",
          }}
        />

        <div
          className="absolute rounded-full border-2"
          style={{
            width: 100,
            height: 100,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderColor: "#FDBE44",
            borderTopColor: "transparent",
            borderRightColor: "rgba(253, 190, 68, 0.3)",
            animation: "spin 1s linear infinite",
          }}
        />

        <div
          className="absolute rounded-full border-2"
          style={{
            width: 85,
            height: 85,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderColor: "#1A47F0",
            borderBottomColor: "transparent",
            borderLeftColor: "rgba(26, 71, 240, 0.3)",
            animation: "spinReverse 1.2s linear infinite",
          }}
        />

        <div
          className="absolute flex items-center justify-center"
          style={{
            width: 64,
            height: 64,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            animation: "iconPulse 2s ease-in-out infinite",
          }}
        >
          <SecurityShieldIcon
            style={{
              width: 64,
              height: 64,
              color: "#1A47F0",
              filter: "drop-shadow(0 4px 8px rgba(26, 71, 240, 0.3))",
            }}
          />
        </div>

        <div
          className="absolute rounded-full"
          style={{
            width: 70,
            height: 70,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background:
              "radial-gradient(circle, rgba(26, 71, 240, 0.2) 0%, transparent 70%)",
            animation: "glow 2s ease-in-out infinite",
          }}
        />
      </div>

      <p
        className="font-medium text-center"
        style={{
          fontSize: 16,
          lineHeight: "24px",
          color: "#222222",
          letterSpacing: "0.02em",
          animation: "fadeInOut 2s ease-in-out infinite",
          fontWeight: 500,
        }}
      >
        {label}
      </p>

      <div className="flex gap-1.5 items-center">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="rounded-full"
            style={{
              width: 6,
              height: 6,
              backgroundColor: "#1A47F0",
              animation: `dotBounce 1.4s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
    </div>
  )

  return (
    <div
      className="inset-0 flex fixed"
      style={{
        zIndex: 10000,
      }}
    >
      <div className="hidden md:flex w-full h-full">
        <div
          style={{
            width: 72,
            height: "100%",
            backgroundColor: "#222222",
          }}
        />

        <div
          className="flex-1 flex flex-col"
          style={{
            height: "100%",
          }}
        >
          <div
            className="border-b"
            style={{
              height: 63,
              width: "100%",
              backgroundColor: "#FFFFFF",
              borderBottomColor: "#E4E4E4",
            }}
          />

          <div
            className="flex-1 flex items-center justify-center"
            style={{
              width: "100%",
              backgroundColor: "#F7F7F7",
            }}
          >
            {renderLoadingContent()}
          </div>
        </div>
      </div>

      <div className="flex md:hidden flex-col w-full h-full">
        <div
          style={{
            height: 52,
            width: "100%",
            backgroundColor: "#222222",
            alignContent: "center",
            paddingLeft: 24,
          }}
        >
          <TraceliumLogo />
        </div>

        <div
          className="border-b"
          style={{
            height: 63,
            width: "100%",
            backgroundColor: "#FFFFFF",
            borderBottomColor: "#E4E4E4",
          }}
        />

        <div
          className="flex-1 flex items-center justify-center"
          style={{
            width: "100%",
            backgroundColor: "#F7F7F7",
          }}
        >
          {renderLoadingContent()}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: translate(-50%, -50%) rotate(0deg); }
          100% { transform: translate(-50%, -50%) rotate(360deg); }
        }
        
        @keyframes spinReverse {
          0% { transform: translate(-50%, -50%) rotate(360deg); }
          100% { transform: translate(-50%, -50%) rotate(0deg); }
        }
        
        @keyframes pulse {
          0%, 100% { 
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.6;
          }
          50% { 
            transform: translate(-50%, -50%) scale(1.1);
            opacity: 0.8;
          }
        }
        
        @keyframes iconPulse {
          0%, 100% { 
            transform: translate(-50%, -50%) scale(1);
          }
          50% { 
            transform: translate(-50%, -50%) scale(1.05);
          }
        }
        
        @keyframes glow {
          0%, 100% { 
            opacity: 0.4;
          }
          50% { 
            opacity: 0.7;
          }
        }
        
        @keyframes fadeInOut {
          0%, 100% { 
            opacity: 0.7;
          }
          50% { 
            opacity: 1;
          }
        }
        
        @keyframes dotBounce {
          0%, 80%, 100% { 
            transform: scale(0.8);
            opacity: 0.5;
          }
          40% { 
            transform: scale(1.2);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  )
}

export default LoadingCheckWorkspace
